import script from "./Authenticate.vue?vue&type=script&setup=true&lang=ts"
export * from "./Authenticate.vue?vue&type=script&setup=true&lang=ts"

import "./Authenticate.vue?vue&type=style&index=0&id=2856dbd4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2856dbd4"]])

export default __exports__